import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SmartModalService } from 'app/core/services/smart-modal.service';
import { CreditService } from '../credit.service';
import { NotificationService } from 'app/core/services/notification.service';
import { SessionService } from 'app/core/services/session.service';
import { ProfileService } from 'app/core/components/profile/profile.service';
import { CreditCommonService } from '../../common/services/credit-common.service';
import { RxComponent } from 'app/core/components/common/rx.component';

@Component({
	selector: 'itpx-approve',
	templateUrl: './approve.component.html',
	styleUrls: ['./approve.component.css']
})
export class ApproveComponent extends RxComponent implements OnInit {

	private details: any;
	private userDetails: any;
	private optionsPaymentTerm: any;
	private isCreditRemoval: boolean = false;
	approveForm: FormGroup;
	constructor(
		private fb: FormBuilder,
		private modalService: SmartModalService,
		private service: CreditService,
		private notificationService: NotificationService,
		private sessionService: SessionService,
		private profileService: ProfileService,
		private creditCommonService: CreditCommonService
	) {
		super()
	}

	ngOnInit() {
		this.details = Object.assign({}, this['data']);
		if (this.details.paymentTerm != null && this.details.paymentTerm.configValue.indexOf('100%') != -1) {
			this.isCreditRemoval = true;
			this.details.requestedCreditLimitAmount = null; // For 100% payment terms credit limit is null;
		}

		if (this.isCreditRemoval == false) {
			this.approveForm = this.fb.group({
				message: ['', Validators.required],
				requestedCreditLimitAmount: ['', Validators.required],
				paymentTerm: ['', Validators.required]
			});
		} else {
			this.approveForm = this.fb.group({
				message: ['', Validators.required],
				requestedCreditLimitAmount: [''],
				paymentTerm: ['', Validators.required]
			});
		}

		this.profileService.getProfile()
			.subscribe(
				body => this.userDetails = body['data']
			);
		this.creditCommonService.getPaymentTermDto()
			.bindToLifecycle(this)
			.subscribe(
				body => {
					let result = [];
					let data = body.data;
					data.forEach(el => {
						if (el.hasOwnProperty('key') && el['value'].indexOf('Days') != -1) {
							result.push(el)
						}
						if (this.isCreditRemoval == true && this.details.paymentTerm.configValue.indexOf('100%') != -1) {
							result.push(el)
						}
					});
					this.optionsPaymentTerm = result;
				}
			)
		this.approveForm.patchValue({
			requestedCreditLimitAmount: this.details.requestedCreditLimitAmount,
			paymentTerm: this.details.paymentTerm ? this.details.paymentTerm.id : null
		})

		if (this.isCreditRemoval == true){
			this.approveForm.controls.paymentTerm.disable();
		}
	}

	private onCancel() {
		this.modalService.close();
	}
	private onSubmit() {
		let details = this['data'];
		details['creditDecision'] = {
			userName: this.userDetails.name,
			userEmail: this.userDetails.username,
			message: this.approveForm.controls.message.value || null,
			approvedCreditLimitAmount: this.approveForm.controls.requestedCreditLimitAmount.value,
			approvedPaymentTerm: { id: this.approveForm.controls.paymentTerm.value }

		}
		this.service.approveCreditApplication(details)
			.subscribe(
				data => {
					this.notificationService.success('The credit application has been approved',
						'Success');
					this.modalService.sendResult('success');
					this.sendEmail();
				},
				error => {
					this.onCancel();
				}
			)
	}

	private sendEmail() {
		let emailDetails = {
			emailTemplate: 'credit-application-approved',
			to: this.details.userEmail,
			extra: {
				message: this.approveForm.controls.message.value,
				name: this.details.userName,

			}
		}

		this.creditCommonService.sendEmail(emailDetails)
			.subscribe(
				data => {
				},
				error => { }
			)
	}
}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/credit/approve/approve.component.ts